import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private messageService = inject(MessageService);

  showSuccess(summary: string = 'Success', message: string = '') {
    this.messageService.add({
      key: 'toast',
      severity: 'success',
      summary: summary,
      detail: message,
    });
  }

  showInfo(summary: string = 'Info', message: string = '') {
    this.messageService.add({
      key: 'toast',
      severity: 'info',
      summary: summary,
      detail: message,
    });
  }

  showWarn(summary: string = 'Warn', message: string = '') {
    this.messageService.add({
      key: 'toast',
      severity: 'warn',
      summary: summary,
      detail: message,
    });
  }

  showError(summary: string = 'Error', message: string = '') {
    this.messageService.add({
      key: 'toast',
      severity: 'error',
      summary: summary,
      detail: message,
    });
  }

  showHttpError(
    error: any,
    summary: string = 'Error',
    defaultMessage: string = 'An error occurred'
  ) {
    // Only show toast for final errors (after all retries are exhausted)
    if (error.isFinalError) {
      console.info(`Showing error toast after ${error.totalAttempts || 1} attempts`);
      this.showError(summary, defaultMessage);
    }
  }
}
